<div class="informe-container">
  <div class="informe-header">
    <irx-segmentado [value]="tipo" (change)="toggleTipo($event.value)">
      <irx-segmento value="cargas">
        <mat-icon>local_gas_station</mat-icon>
        Cargas
      </irx-segmento>
      <irx-segmento value="sospechosos">
        <mat-icon>warning</mat-icon>
        Sospechosos
      </irx-segmento>
      <irx-segmento value="mensual">
        <mat-icon>summarize</mat-icon>
        Mensual
      </irx-segmento>
    </irx-segmentado>

    <div class="header-acciones">
      <irx-segmentado
        [value]="periodo"
        (change)="togglePeriodo($event.value)"
      >
        <irx-segmento [value]="7">7 días</irx-segmento>
        <irx-segmento [value]="30">30 días</irx-segmento>
      </irx-segmentado>

      <button
        irxBotonIcono
        (click)="verInforme()"
        [disabled]="!informeActual"
        tooltip="Ver / imprimir informe seleccionado"
      >
        <mat-icon>print</mat-icon>
      </button>

      <div style="width: 160px">
        <app-date-picker
          mode="date"
          label="Fecha"
          [maxDate]="ayer"
          [(ngModel)]="fechaISO"
          (ngModelChange)="onFechaChange()"
        ></app-date-picker>
      </div>

      <button
        irxBotonIcono
        (click)="generarInforme()"
        [disabled]="generando"
        tooltip="Generar informe para la fecha seleccionada"
      >
        @if (generando) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <mat-icon>summarize</mat-icon>
        }
      </button>
    </div>
  </div>

  @if (cargando) {
    <div class="estado-centro">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (informes.length === 0) {
    <div class="estado-centro">
      <mat-icon>inbox</mat-icon>
      <p>No hay informes generados para el período seleccionado</p>
    </div>
  } @else {
    <app-carrusel
      [itemCount]="informes.length"
      (indexChange)="onIndexChange($event)"
    >
      @if (informeActual) {
        <p class="slide-fecha">
          {{
            informeActual.periodoInicio
              | date: "EEEE d 'de' MMMM 'de' yyyy" : undefined : 'es-AR'
          }}
          @if (!idActivo && informeActual.cliente?.nombre) {
            <span class="slide-cliente">
              <mat-icon inline>business</mat-icon>
              {{ informeActual.cliente?.nombre }}
              @if (esInformePropio) {
                (sumatoria)
              }
            </span>
          }
        </p>
        <div class="slide-resumen">
          @if (tipo === 'cargas') {
            <span class="chip chip-blue">
              <mat-icon>local_gas_station</mat-icon>
              {{ resumenFiltrado?.totalCargas ?? 0 }} cargas
            </span>
            <span class="chip chip-green">
              <mat-icon>water_drop</mat-icon>
              {{ resumenFiltrado?.totalLitrosCargados ?? 0 | number: '1.0-0' }}
              L
            </span>
            @if (!idActivo) {
              <span class="chip chip-gray">
                <mat-icon>directions_car</mat-icon>
                {{ resumenFiltrado?.vehiculosConCarga ?? 0 }} vehículos
              </span>
            }
          }
          @if (tipo === 'sospechosos') {
            <span class="chip chip-red">
              <mat-icon>warning</mat-icon>
              {{ resumenFiltrado?.totalEventos ?? 0 }} eventos
            </span>
            <span class="chip chip-orange">
              <mat-icon>water_drop</mat-icon>
              {{
                resumenFiltrado?.totalLitrosDescargados ?? 0 | number: '1.0-0'
              }}
              L
            </span>
            @if (!idActivo) {
              <span class="chip chip-gray">
                <mat-icon>directions_car</mat-icon>
                {{ resumenFiltrado?.vehiculosAfectados ?? 0 }} vehículos
              </span>
            }
          }
          @if (tipo === 'mensual') {
            <span class="chip chip-blue">
              <mat-icon>speed</mat-icon>
              {{ resumenFiltrado?.kmTotales ?? 0 | number: '1.0-0' }} km
            </span>
            <span class="chip chip-green">
              <mat-icon>water_drop</mat-icon>
              {{ resumenFiltrado?.litrosTotales ?? 0 | number: '1.0-0' }} L
            </span>
            @if (!idActivo) {
              <span class="chip chip-gray">
                <mat-icon>directions_car</mat-icon>
                {{ resumenFiltrado?.totalVehiculos ?? 0 }} vehículos
              </span>
            }
          }
        </div>
      }
    </app-carrusel>
  }
</div>
